"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var unCloak = function unCloak() {
  var cloakClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cloak';
  var elements = document.querySelectorAll(".".concat(cloakClass));
  Array.from(elements).forEach(function (element) {
    element.classList.remove(cloakClass);
  });
};

var _default = unCloak;
exports["default"] = _default;